import { Suspense, useState } from 'react'
import Skeleton from './Skeleton'
import FeedBackBot from './BotChat'
import { faChevronDown, faChevronUp, faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const LiveDoubtSolving = () => {

    const [showBot, setShowBot] = useState(false);

    return (
        <div className='mt-3 bg-[#2D4F71] p-3 rounded-xl'>
            <div className='flex items-center justify-between cursor-pointer' onClick={() => setShowBot(!showBot)}>
                <div className='flex'>
                    <FontAwesomeIcon icon={faCircleCheck} className='text-[#55A47E] bg-white rounded-full text-xl mr-2'/>
                    <p className='font-medium'>Live Doubt Solving</p>
                </div>
                {!showBot ?  <FontAwesomeIcon icon={faChevronDown} className='text-xl font-extrabold ml-2' onClick={() => setShowBot(!showBot)}/> : <FontAwesomeIcon icon={faChevronUp} className='text-xl font-extrabold ml-2 mt-1.5'/>}
            </div>
            {showBot && <Suspense fallback={<Skeleton/>}><FeedBackBot/></Suspense>}
        </div>
    )
}

export default LiveDoubtSolving
